// src/components/ui/MobileAtmosphericLighting.tsx
import React from 'react';

/**
 * Mobile Atmospheric Lighting Component
 * 
 * Provides atmospheric background lighting effects for mobile devices.
 * Uses fixed positioning and controlled dimensions to prevent viewport overflow.
 * 
 * Features:
 * - Two circular gradient overlays (primary and gray)
 * - Fixed positioning to prevent horizontal scroll issues
 * - Only visible on mobile devices (md:hidden)
 * - Static decorative elements with accessibility considerations
 * - Reduced blur radius (80px) and viewport dimensions (120vw/vh)
 * - Accessibility-friendly with aria-hidden and pointer-events-none
 * - No interaction interference with underlying UI elements
 * 
 * Note: While optimized, blur effects still require GPU compositing
 */
const MobileAtmosphericLighting: React.FC = () => (
  <>
    {/* Mobile atmospheric lighting - Fixed positioning to prevent viewport overflow */}
    <div
      aria-hidden="true"
      className="atmospheric-blob top-0 right-0 bg-primary-500/10"
    ></div>
    <div
      aria-hidden="true"
      className="atmospheric-blob bottom-0 left-0 bg-gray-300/15"
    ></div>
  </>
);

export default MobileAtmosphericLighting;